import { MutableRefObject } from "react"
import { RequestResponseChannel } from "../machines/data-load-machine"

export type ChannelStatus = "ready" | "notReady"

export class IsomorphicRequestResponseChannel implements RequestResponseChannel {
    private realChannelRef: MutableRefObject<RequestResponseChannel | undefined>

    constructor(realChannelRef: MutableRefObject<RequestResponseChannel | undefined>) {
        this.realChannelRef = realChannelRef
    }

    sendAndReceive(message: Record<string, unknown>): Promise<Record<string, unknown>> {
        if (this.realChannelRef.current === undefined) return Promise.reject(new Error("Channel still not available"))
        return this.realChannelRef.current.sendAndReceive(message)
    }

    status(): ChannelStatus {
        return this.realChannelRef.current === undefined ? "notReady" : "ready"
    }
}
